import BaseComponent from '@/js/core/BaseComponent'
import Events from '@/js/core/EventDispatcher'
import $ from 'jquery'

export default class Router extends BaseComponent {
  static root = 'body'

  selectors = {
    'link[]': '[data-router-link]'
  }

  listeners = {
    'click @link': (event) => {
      this.routerLink(event)
    }
  }

  routerLink (event) {
    if ($.device.mobile) return
    const { href } = event.currentTarget
    Events.emit('router:push', { href })
    event.preventDefault()
  }

  mounted () {
    super.mounted()

    $(document)
      .on('click', '[data-router-link]', (event) => {
        this.routerLink(event)
      })
  }
}